/**
 * Global exports and legacy compatibility layer
 */

// Global exports for Phase 3 functions - ensure they're available
export function setupGlobalExports({
    getMatchConditions,
    myEach,
    addCategoryMatchConditions,
    substringMatcher,
    generateFilterReport,
    testFilterFunctionality,
    validateDataIntegrity,
    simulateFilterApplication,
    fileLoader,
    fileProcessor,
    filesCacheManager,
    searchProgressManager,
    paginationController,
    filterController,
    dateFiltersManager,
    formHandler,
    cardController,
    cardEventsManager,
    appInitializationManager,
    bootstrapManager,
    tabManager,
    dateParser,
    dateFormatter,
    dateValidator,
    timezoneManager
}) {
    // Phase 3 functions
    window.getMatchConditions = getMatchConditions;
    window.myEach = myEach;
    window.addCategoryMatchConditions = addCategoryMatchConditions;
    window.substringMatcher = substringMatcher;

    // Phase 11 diagnostic functions
    window.generateFilterReport = generateFilterReport;
    window.testFilterFunctionality = testFilterFunctionality;
    window.validateDataIntegrity = validateDataIntegrity;
    window.simulateFilterApplication = simulateFilterApplication;

    // Phase 4 functions - file management
    window.fileLoader = fileLoader;
    window.fileProcessor = fileProcessor;
    window.filesCacheManager = filesCacheManager;

    // Phase 5 functions - UI components
    window.searchProgressManager = searchProgressManager;
    window.paginationController = paginationController;

    // Phase 6 functions - filters and forms
    window.filterController = filterController;
    window.dateFiltersManager = dateFiltersManager;
    window.formHandler = formHandler;

    // Phase 7 functions - card management
    window.cardController = cardController;
    window.cardEventsManager = cardEventsManager;

    // Phase 8 functions - app initialization & bootstrap
    window.appInitializationManager = appInitializationManager;
    window.bootstrapManager = bootstrapManager;
    window.tabManager = tabManager;

    // Phase 9 functions - date & time management
    window.dateParser = dateParser;
    window.dateFormatter = dateFormatter;
    window.dateValidator = dateValidator;
    window.timezoneManager = timezoneManager;
}

// CRITICAL: Ensure legacy filter functions are available globally
export function checkLegacyCompatibility(debugMode) {
    if (typeof window.onDropDownChange === 'undefined') {
    }
    if (typeof window.resetAccountAutocompletion === 'undefined') {
    }

    // CRITICAL: Initialize legacy variables for filter compatibility
    if (typeof window.search_categories === 'undefined') {
        window.search_categories = [];
    }

    // CRITICAL: Ensure generateSuggestionTemplate is available
    if (!window.generateSuggestionTemplate) {
        window.generateSuggestionTemplate = function(data) {
            return `<div class="suggestion-item">
                <div class="suggestion-name">${data.name || 'Unknown'}</div>
                <div class="suggestion-path">${data.path || ''}</div>
            </div>`;
        };
    }
}

